import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const BUILD_ID = process.env.REACT_APP_BUILD_ID;
const BUILD_ID_STORAGE_KEY = 'peckdating:buildId';

async function clearBrowserCachesBestEffort() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (_) {
    // best effort
  }

  try {
    if (typeof caches !== 'undefined' && caches.keys) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (_) {
    // best effort
  }
}

async function bustCacheOnNewDeployBestEffort() {
  if (!BUILD_ID) return;

  const previous = localStorage.getItem(BUILD_ID_STORAGE_KEY);
  if (!previous) {
    localStorage.setItem(BUILD_ID_STORAGE_KEY, BUILD_ID);
    return;
  }

  if (previous !== BUILD_ID) {
    localStorage.setItem(BUILD_ID_STORAGE_KEY, BUILD_ID);
    await clearBrowserCachesBestEffort();
    window.location.reload();
  }
}

// Run before app mount to avoid flashing old UI.
void bustCacheOnNewDeployBestEffort();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
